import moment, { Moment } from 'moment'
import { PeriodoGestacaoModel } from 'view/atendimentos/detail/components/modals/types/PeriodoGestacaoModel'

export function filterGestacoesPeriodo(gestacoes: ReadonlyArray<PeriodoGestacaoModel>, init: Moment, end: Moment) {
  return gestacoes.filter((g) => moment(g.inicio).isBefore(end) && getFim(g.inicio, g.fim).isAfter(init))
}

const getFim = (inicio: any, fim: any) => (fim ? moment(fim) : moment(inicio).add(42, 'weeks'))
